import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { brandActions } from '../../../store/modules/brand';

export const useBrandDetailOrderBalance = (storeId) => {
  const dispatch = useDispatch();

  // redux store에서 브랜드 주문/정산 정보 조회
  const selectOrderSummaryInfo = (state) => state.brand.brandDetail.orderSummaryInfo;
  const selectBalanceSummaryInfo = (state) => state.brand.brandDetail.balanceSummaryInfo;

  // 마운트시에 브랜드 주문/정산 정보 불러오기
  useEffect(() => {
    dispatch(brandActions.getBrandDetailOrderBalance({ storeId }));
  }, [storeId, dispatch]);

  const orderSummaryInfo = useSelector(selectOrderSummaryInfo);
  const balanceSummaryInfo = useSelector(selectBalanceSummaryInfo);

  return { orderSummaryInfo, balanceSummaryInfo };
};
